import api from '@/utils/api';

/**
 * delete quote
 *
 * @param {string} quoteId - The quote id
 * @returns {Promise} The promise object of the api call
 */
const deleteQuoteApi = (quoteId) => api.delete(`quote/${quoteId}`);

export default deleteQuoteApi;
